module.exports = __webpack_public_path__ + "static/media/cog-outline.4593f65f.png";